import { IComponent } from "../../component.interface";
import { IDrawingTool } from "../drawing-tool.interface";
import { DrawingToolsManager } from "../drawing-tools.manager";

export class FibonacciTimezonesComponent implements IComponent, IDrawingTool {
    public id = '';

    public annotation: any = null;
    private drawingToolManager: DrawingToolsManager;

    constructor(drawingToolManager: DrawingToolsManager, id: string) {
        this.drawingToolManager = drawingToolManager;
        this.id = id;
    }

    public static syncCreate(drawingToolManager: DrawingToolsManager, annotationOptions: any): FibonacciTimezonesComponent {
        const chart: any = drawingToolManager.base.tiChartSeries.highStockChart;
        const addedNewAnnotation: any = chart.addAnnotation(annotationOptions);

        drawingToolManager.updateAnnotationStyles(addedNewAnnotation, annotationOptions, false);
        const component = new FibonacciTimezonesComponent(drawingToolManager, annotationOptions.id);
        component.annotation = addedNewAnnotation;
        return component;
    }

    public static create(drawingToolManager: DrawingToolsManager, event: any): FibonacciTimezonesComponent {
        const component = new FibonacciTimezonesComponent(drawingToolManager, event.options.id);
        component.annotation = event;
        return component;
    }

    public syncUpdate(annotationOptions: any) {

    }

    public getMetaData(): any {
        return {
            id: this.id,
            langKey: "fibonacciTimeZones",
            type: 'fibonacciTimeZones', // options type
            typeOptions: {
                xAxis: this.annotation.options.typeOptions.xAxis,
                yAxis: this.annotation.options.typeOptions.yAxis,
                height: this.annotation.options.typeOptions.height,
                backgroundColors: this.annotation.options.typeOptions.backgroundColors,
                lineColor: this.annotation.options.typeOptions.lineColor,
                lineColors: this.annotation.options.typeOptions.lineColors,
                labels: this.annotation.options.typeOptions.labels,
                points: [{
                    x: this.annotation.userOptions.typeOptions.points[0].x,
                    xAxis: this.annotation.userOptions.typeOptions.points[0].xAxis,
                }, {
                    x: this.annotation.userOptions.typeOptions.points[1]?.x,
                    xAxis: this.annotation.userOptions.typeOptions.points[1]?.xAxis,
                }
                
            ]   
            },
            labelOptions: this.annotation.options.labelOptions,         
        };
    }
}